query orgaoSelect {
    data: orgaosAll(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}